import api from '../../../global/api';

type Data = {
  batchOrderId: string;
  fusionFiscalStartDate: string;
};

export function editFusionBatchOrderApi(data: Data) {
  return api.put(`/batch/order/${data.batchOrderId}`, {
    id: data.batchOrderId,
    fusionFiscalStartDate: data.fusionFiscalStartDate,
  });
}
